import React from 'react';

export const CREANDO_PEDIDO_STEPS = [
  'Preparando pedido',
  'Calculando ruta',
  'Registrando información',
];

function TruckSvg() {
  return (
    <svg
      className="lt-pedido-overlay__truck-svg"
      viewBox="0 0 96 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <ellipse cx="22" cy="40" rx="7" ry="7" fill="#0F172A" />
      <ellipse cx="22" cy="40" rx="3.5" ry="3.5" fill="#94A3B8" />
      <ellipse cx="68" cy="40" rx="7" ry="7" fill="#0F172A" />
      <ellipse cx="68" cy="40" rx="3.5" ry="3.5" fill="#94A3B8" />
      <rect x="34" y="18" width="48" height="20" rx="2" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="1" />
      <rect x="38" y="22" width="40" height="12" rx="1" fill="#F1F5F9" />
      <rect x="38" y="22" width="40" height="3" fill="#2563EB" opacity="0.85" />
      <path d="M8 28h18v10H8z" fill="#2563EB" />
      <path d="M6 24h14v8h-2a4 4 0 0 0-4-4V24z" fill="#1D4ED8" />
      <rect x="10" y="26" width="8" height="6" rx="1" fill="#EFF6FF" stroke="#93C5FD" strokeWidth="0.5" />
      <rect x="30" y="30" width="4" height="8" fill="#CBD5E1" />
      <circle cx="12" cy="21" r="2" fill="#FBBF24" />
    </svg>
  );
}

export default function CreandoPedidoOverlay({ status = 'loading' }) {
  const busy = status === 'loading';

  return (
    <div
      className="lt-pedido-overlay"
      role="status"
      aria-live="polite"
      aria-busy={busy}
      aria-label={status === 'success' ? 'Pedido creado' : 'Creando pedido'}
    >
      <div className="lt-pedido-overlay__panel">
        {status === 'success' ? (
          <div className="lt-pedido-overlay__success">
            <div className="lt-pedido-overlay__success-icon" aria-hidden="true">
              ✔
            </div>
            <p className="lt-pedido-overlay__success-text">Pedido creado</p>
            <p className="lt-pedido-overlay__success-sub">Tu pedido ha sido creado correctamente.</p>
          </div>
        ) : (
          <>
            <div className="lt-pedido-overlay__header">
              <h3 className="lt-pedido-overlay__title">Creando pedido...</h3>
              <p className="lt-pedido-overlay__subtitle">
                Por favor espera mientras preparamos todo.
              </p>
            </div>
            <div className="lt-pedido-overlay__scene" aria-hidden="true">
              <div className="lt-pedido-overlay__road">
                <div className="lt-pedido-overlay__road-surface" />
                <div className="lt-pedido-overlay__road-dash" />
                <div className="lt-pedido-overlay__truck">
                  <TruckSvg />
                </div>
              </div>
              <div className="lt-pedido-overlay__timeline">
                <span className="lt-pedido-overlay__dot lt-pedido-overlay__dot--1" />
                <span className="lt-pedido-overlay__line" />
                <span className="lt-pedido-overlay__dot lt-pedido-overlay__dot--2" />
                <span className="lt-pedido-overlay__line" />
                <span className="lt-pedido-overlay__dot lt-pedido-overlay__dot--3" />
              </div>
            </div>
            <div className="lt-pedido-overlay__steps">
              {CREANDO_PEDIDO_STEPS.map((label, i) => (
                <p
                  key={label}
                  className={`lt-pedido-overlay__step lt-pedido-overlay__step--${i + 1}`}
                >
                  {label}
                </p>
              ))}
            </div>
            <div className="lt-pedido-overlay__progress-track">
              <div className="lt-pedido-overlay__progress-fill" />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
